import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { getAction } from '@/api/manage';
import { downloadFile } from '@/api/manage';
export default {
  name: 'LogSiteList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {},
  data: function data() {
    return {
      autoLoadInit: false,
      pageTitle: '站点设备因子',
      assetList: [],
      // 表头
      columns: [// {
      //     title: '序号',
      //     dataIndex: '',
      //     key: 'rowIndex',
      //     width: 60,
      //     align: "center",
      //     customRender: function (t, r, index) {
      //         return parseInt(index) + 1;
      //     }
      // },
      {
        dataIndex: 'name',
        colName: 'name',
        title: '设备名称',
        align: 'center'
      }, {
        dataIndex: 'factorName',
        colName: 'factorName',
        title: '因子名称',
        align: 'center'
      }, {
        dataIndex: 'factorCode',
        colName: 'factorCode',
        title: '监测因子',
        align: 'center'
      }, {
        dataIndex: 'insideNumber',
        colName: 'insideNumber',
        title: '内部编号',
        align: 'center'
      }, {
        dataIndex: 'code',
        colName: 'code',
        title: '因子编码',
        align: 'center'
      }, {
        dataIndex: 'factorUnit',
        colName: 'factorUnit',
        title: '因子单位',
        align: 'center'
      }]
    };
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];
      this.queryParam.siteId = ids[1];
      this.delayLoadData();
      this.loadAsset();
    }
  },
  created: function created() {},
  computed: {},
  methods: {
    loadAsset: function loadAsset() {
      var that = this;
      that.companyList = [];
      getAction('/ea/asset/equipment/querySiteDevice/' + that.queryParam.siteId).then(function (res) {
        if (res.success) {
          res.result.forEach(function (element) {
            if (element.insideName != undefined) element.name = element.insideName;
          });
          that.assetList = res.result;
        }
      });
    },
    initTableData: function initTableData(arg) {
      var _this = this;

      //debugger
      //if(!this.url.list){
      // this.$message.error("请设置url.list属性!")
      // return
      // }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      this.loading = true;
      getAction('/ea/asset/equipment/querySiteDeviceFactor', params).then(function (res) {
        if (res.success) {
          _this.dataSource = res.result.records;
        } else {
          _this.$message.warning('系统异常=>' + res.message);
        }

        _this.loading = false;
      });
    },
    handleExportXls: function handleExportXls(s) {
      var url = '/ea/asset/equipment/siteDeviceFactor/exportXls';
      downloadFile(s, url, this.queryParam);
    }
  }
};